<!-- MODAL HEADER-->
<div class="row modal-bar">
    <div class="col-sm-10">
        <h5 class="modal-title">{{ 'DIALOGS.VISITOR_VERIFICATION_INFO.TITLE' | translate }}</h5>
    </div>
    <div class="col-sm-2">
        <div class="modal-actions">
            <div class="modal-close">
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="dialogRef.close(false);"></button>
            </div>
        </div>
    </div>
  </div>

  @if (!loading) {
    
    @if (data != null) {

        <div class="visitor-info">
            <div class="visitor-photo">

                @if (data.ImageBase64 == null) {
                    <div class="no-image">
                        {{ 'DIALOGS.VISITOR_VERIFICATION_INFO.NO-IMAGE' | translate }}
                    </div>
                }
                @else {
                    <img 
                        [src]="photoUrl" 
                        width="120"
                    />
                }
                
            </div>

            <div class="visitor-details">
                <h2 class="visitor-name">{{data.FirstName + ' ' + data.LastName}}</h2>

                <div class="info-group">
                    <div class="info-item">
                        <span class="label">{{ 'DIALOGS.VISITOR_VERIFICATION_INFO.LABEL.DATEOFBIRTH' | translate }}:</span>
                        <span class="value">{{ $any(data.DateOfBirth) | localDate | replaceOnEmpty }}</span>
                    </div>

                    <div class="info-item">
                        <span class="label">{{ 'DIALOGS.VISITOR_VERIFICATION_INFO.LABEL.GENDER' | translate }}:</span>
                        <span class="value">{{ genderString | translate | replaceOnEmpty }}</span>
                    </div>

                    <div class="info-item">
                        <span class="label">{{ 'DIALOGS.VISITOR_VERIFICATION_INFO.LABEL.NATIONALITY' | translate }}:</span>
                        <span class="value">{{ data.Nationality | replaceOnEmpty }}</span>
                    </div>

                    <div class="info-item">
                        <span class="label">{{ 'DIALOGS.VISITOR_VERIFICATION_INFO.LABEL.DOCUMENTTYPE' | translate }}:</span>
                        <span class="value">{{ data.DocumentType | replaceOnEmpty }}</span>
                    </div>

                    <div class="info-item">
                        <span class="label">{{ 'DIALOGS.VISITOR_VERIFICATION_INFO.LABEL.EXPIRATIONDATE' | translate }}:</span>
                        <span class="value">{{ $any(data.ExpirationDate) | localDate | replaceOnEmpty}}</span>
                    </div>
                </div>
            </div>
        </div>
    }
    @else {
        <div class="pt-3">{{'DIALOGS.VISITOR_VERIFICATION_INFO.NODATA' | translate}}</div>
    }
  }
  
